var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgHeartRed = function SvgHeartRed(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3246 1.79817C12.0196 1.4949 11.6573 1.25432 11.2587 1.09018C10.86 0.926036 10.4327 0.841553 10.0012 0.841553C9.56962 0.841553 9.14231 0.926036 8.74365 1.09018C8.34498 1.25432 7.98276 1.4949 7.67769 1.79817L7.04456 2.42728L6.41142 1.79817C5.7952 1.18586 4.95942 0.84187 4.08795 0.84187C3.21648 0.84187 2.3807 1.18586 1.76448 1.79817C1.14825 2.41048 0.802063 3.24095 0.802063 4.10689C0.802063 4.97283 1.14825 5.8033 1.76448 6.41561L2.39761 7.04472L7.04456 11.6622L11.6915 7.04472L12.3246 6.41561C12.6298 6.11247 12.872 5.75256 13.0372 5.35642C13.2023 4.96028 13.2874 4.53569 13.2874 4.10689C13.2874 3.67809 13.2023 3.2535 13.0372 2.85736C12.872 2.46122 12.6298 2.10131 12.3246 1.79817Z",
    fill: "#F15A28"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgHeartRed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/heart-red.36fbfddd49d91c7a8ceaa39949405f39.svg";